import { Skeleton } from 'antd'
import type { ReactNode } from 'react'

import { cx } from '@/Ship/Helpers/cssClass'

import styles from './Report.module.css'

export interface ReportKpi {
    key: string
    label: string
    value: ReactNode
    hint?: ReactNode
    /** Значення — довільний блок (напр., смужка розподілу), а не велике число */
    plain?: boolean
    /** Показник займає більше місця в смузі (напр., розподіл із легендою) */
    wide?: boolean
}

interface ReportSummaryProps {
    items: ReportKpi[]
    loading: boolean
}

/** Підсумки звіту за фільтрами — смуга показників між фільтром і таблицею */
export const ReportSummary = ({ items, loading }: ReportSummaryProps) => (
    <div className={cx(styles, 'summary')} aria-live="polite">
        {items.map((item) => (
            <div key={item.key} className={`${cx(styles, 'kpi')} ${item.wide ? cx(styles, 'kpiWide') : ''}`}>
                <span className={cx(styles, 'kpiLabel')}>{item.label}</span>
                {loading ? (
                    <Skeleton.Input active size="small" style={{ width: 72, minWidth: 72, height: 24 }} />
                ) : (
                    <>
                        {item.plain ? (
                            <div className={cx(styles, 'kpiPlain')}>{item.value}</div>
                        ) : (
                            <span className={cx(styles, 'kpiValue')}>{item.value}</span>
                        )}
                        {item.hint && <span className={cx(styles, 'kpiHint')}>{item.hint}</span>}
                    </>
                )}
            </div>
        ))}
    </div>
)
